import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSchemeServiceItemListDataApi(data) {
  return request({
    url: 'tms-web/schemeServiceItem/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSchemeServiceItemListDataApi(data) {
  return request({
    url: 'tms-web/schemeServiceItem/exportByPage',
    method: 'post',
    data
  })
}

// 合计
export function sumSchemeServiceItemListDataApi(data) {
  return request({
    url: 'tms-web/schemeServiceItem/sumByPage',
    method: 'post',
    data
  })
}

// 统计待办任务数量
export function countTodoServiceItemApi(data) {
  return request({
    url: 'tms-web/schemeServiceItem/countTodo',
    method: 'post',
    data
  })
}
